import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import Field from '@starbucks-web/pattern-library/lib/components/field';
import shouldDisplayError from '@starbucks-web/pattern-library/lib/components/form-container/should-display-error';
import Button from '@starbucks-web/pattern-library/lib/components/button';

import { prefixErrorMessage } from 'shared/app/components/a11y-error-message-prefix';

import CantAccessEmailUrl from '../cant-access-email';

import { formMessages } from 'shared/app/messages';
import sharedMessages from '../../messages';
import messages from './messages';

export const ForgotPasswordColumn = ({ fields }) => {
  const { formatMessage } = useIntl();

  return (
    <React.Fragment>
      <Field
        {...fields.emailAddress.input}
        autoComplete="email"
        className="my3"
        data-e2e="emailAddressField"
        error={shouldDisplayError(fields.emailAddress)}
        errorMessage={prefixErrorMessage(
          fields.emailAddress.errorDetails.existence
            ? messages.existenceError
            : messages.invalidError
        )}
        maxLength={50}
        maxLengthAriaMessage={formatMessage(formMessages.maxLengthAriaMessage)}
        type="email"
      >
        {formatMessage(sharedMessages.emailLabel)}
      </Field>

      <CantAccessEmailUrl />
      <Button
        className="mt6 block"
        data-e2e="resetPasswordButton"
        type="submit"
        visualStyle="positive"
      >
        {formatMessage(messages.resetPassword)}
      </Button>
    </React.Fragment>
  );
};

ForgotPasswordColumn.propTypes = {
  fields: PropTypes.object,
};

export default ForgotPasswordColumn;
